import { render, staticRenderFns } from "./ReservationSetting.vue?vue&type=template&id=459df8b4&scoped=true&"
import script from "./ReservationSetting.vue?vue&type=script&lang=js&"
export * from "./ReservationSetting.vue?vue&type=script&lang=js&"
import style0 from "./ReservationSetting.vue?vue&type=style&index=0&id=459df8b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459df8b4",
  null
  
)

export default component.exports